<script setup>
  import _ from 'lodash'
  const props = defineProps({
    languages: {
      type: Array,
      required: true,
    },
    location: {
      type: null,
      required: false,
      default: 'bottom end',
    },
  })

  const {
    locale
  } = useI18n({
    useScope: 'global'
  })

  function label(locale) {
    return _.chain(props.languages).find(a => a.i18nLang === locale).get('label').value()
  }

  const languageCookie = useCookie('locale')
  const mlanguageCookie = useCookie('materio-language')
  const route = useRoute()
  const uuid = computed(() => route.params.uuid)

  function changeLocale(lang) {
    mlanguageCookie.value = lang
    languageCookie.value = lang
    locale.value = lang
    if (route.name === 'lang-quick-view-ph-on') {
      navigateTo({
        path: `/${lang}/quick-view/ph-on`,
        replace: true
      })
      return
    } else {
      navigateTo({
        path: `/${lang}/quick-view/${uuid.value}`,
        replace: true
      })
    }
  }
</script>

<template>
  <!-- <div class="mr-2 text-body-2 font-weight-bold">
    {{ label(locale) }}
  </div> -->
  <IconBtn class="mr-1" data-testid="user-locale">
    <VIcon icon="ri-translate-2" />
    <!-- Menu -->
    <VMenu activator="parent" :location="props.location" offset="15px" width="160">
      <!-- List -->
      <VList :selected="[locale]" color="primary" mandatory>
        <!-- List item -->
        <VListItem v-for="lang in props.languages" :key="lang.i18nLang" :value="lang.i18nLang"
          @click="changeLocale(lang.i18nLang)" :data-testid="'user-locale-' + lang.i18nLang">
          <!-- Language label -->
          <VListItemTitle>{{ lang.label }}</VListItemTitle>
        </VListItem>
      </VList>
    </VMenu>
  </IconBtn>
</template>